import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentsIconUnselected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0312 14.24L13.0012 22L16.0012 16L27.0012 2L12.0312 14.24Z",
			stroke: "currentColor",
			strokeWidth: .970588,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 16L13 22L20.76 18.12L16 16Z",
			stroke: "currentColor",
			strokeWidth: .970588,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12L12.03 14.24L27 2L7 12Z",
			stroke: "currentColor",
			strokeWidth: .970588,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 16L25 20L27 2L16 16Z",
			stroke: "currentColor",
			strokeWidth: .970588,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 4H4.5625C3.70312 4 3 4.70312 3 5.5625V27.4375C3 28.2969 3.70312 29 4.5625 29H26.4375C27.2969 29 28 28.2969 28 27.4375V15.5",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDocumentsIconUnselected;
